export {default} from '../../../core/components/Repository/DetailForm';